var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79882 11.8682L5.35254 9.43652C5.28418 9.36816 5.25 9.28027 5.25 9.17284C5.25 9.06542 5.28418 8.97753 5.35254 8.90917L5.89453 8.38183C5.96289 8.30371 6.04834 8.26465 6.15088 8.26465C6.25342 8.26465 6.34375 8.30371 6.42187 8.38183L8.06249 10.0225L11.5781 6.50684C11.6562 6.42871 11.7466 6.38965 11.8491 6.38965C11.9516 6.38965 12.0371 6.42871 12.1055 6.50684L12.6474 7.03418C12.7158 7.10254 12.75 7.19043 12.75 7.29785C12.75 7.40527 12.7158 7.49316 12.6474 7.56152L8.32616 11.8682C8.25781 11.9463 8.16991 11.9853 8.06249 11.9853C7.95507 11.9853 7.86718 11.9463 7.79882 11.8682Z",
    fill: "#50C8ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesIcon);
export default __webpack_public_path__ + "static/media/yes-icon.fe1474e0a154e63c65f0354f70b49bcf.svg";
export { ForwardRef as ReactComponent };